<div *ngIf="applicant.id === 0" class="flex flex-col">
  <div class="flex flex-col md:flex-row gap-4 justify-start items-center">
    <span class="f-s-18"><strong>Entity Applicants</strong></span>
    <mat-form-field class="md:w-[40%] w-full">
      <input matInput (keyup)="filterTable($event)" placeholder="Filter Applicants" />
    </mat-form-field>
    <span class="flex-1"></span>
    <span>Click to Edit</span>
    <button *ngIf="!licenseLocked && !renewal"
            mat-icon-button
            type="button"
            color="primary"
            (click)="addApplicant()"
            aria-label="Add Applicant"
            matTooltip="Add Applicant"
            matTooltipPosition="below"
            [matTooltipShowDelay]="500">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <mat-table [dataSource]="dataSource" matSort #sort="matSort" aria-describedby="applicants"
    class="mat-elevation-z8 p-t-0">
    <ng-container matColumnDef="entityName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Entity</mat-header-cell>
      <mat-cell (click)="editApplicant(applicant)" [ngClass]="tableColor" tabindex="0" *matCellDef="let applicant">
        <span class="mobile-label">Entity</span>
        {{ applicant.entityName }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="complete">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
      <mat-cell (click)="editApplicant(applicant)" [ngClass]="tableColor" tabindex="0" *matCellDef="let applicant">
        <span class="mobile-label">Status</span>
        <span *ngIf="applicant.complete" class="text-light-green-600">Complete</span>
        <span *ngIf="!applicant.complete" class="text-red-400">Incomplete</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell [ngClass]="tableColor" *matCellDef="let applicant">
        <button *ngIf="!licenseLocked && !renewal && status == 'Pending'" mat-icon-button (click)="deleteApplicant(applicant)" color="warn" aria-label="Delete Applicant">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="dataColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: dataColumns"></mat-row>
  </mat-table>
  <mat-paginator [pageSizeOptions]="[5, 20, 50]" #paginator="matPaginator">
  </mat-paginator>
</div>

<mat-card [style.background-color]="cardColor" *ngIf="applicant.id > 0">
  <mat-card-title>
    <div class="flex flex-col md:flex-row gap-2 justify-start items-center">
      <span>{{addingApplicant? 'Add An Entity Applicant' : 'Editing ' + applicant.entityName}}</span>
      <span class="flex-1"></span>
      <button mat-flat-button type="button" color="warn" (click)="cancel()">{{addingApplicant? 'Cancel' : 'Close'}}</button>
      <button *ngIf="!licenseLocked" mat-flat-button type="button" color="primary"
        (click)="saveApplicant(false)">Save</button>
      <button *ngIf="!licenseLocked" mat-flat-button type="button" color="primary"
        (click)="saveApplicant(true)">Save and Close</button>
    </div>
  </mat-card-title>

  <div *ngIf="renewal" class="flex flex-row">
    <span class="flex-1"></span>
    <form [formGroup]="applicantForm">
      <span class="flex-1"></span>
      <mat-card class="flex flex-col gap-2">
        <div class="flex flex-row">
            <div class="flex flex-col gap-2">
              <span class="text-wrap" [ngStyle]="{'color': applicantForm.get('applicantPageCorrect').hasError('required')? 'red' : 'black'}">Is all the information on this screen current and correct?</span>
              <span id="applicantPageCorrect" class="text-wrap"><i>Some information may be outdated or incorrect but you cannot change it on this application.
                These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</i></span>
              <mat-radio-group aria-label="Select an option" formControlName="applicantPageCorrect" aria-describedby="applicantPageCorrect" class="gap-2">
                <mat-radio-button [value]="true">Yes</mat-radio-button>
                <mat-radio-button [value]="false">No</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="applicantForm.get('applicantPageCorrect').hasError('required')">This field is required</mat-error>
            </div>
        </div>

        <div *ngIf="applicantForm.get('applicantPageCorrect').value == false" class="flex flex-row">
          <div class="flex flex-col">
             <mat-form-field>
              <textarea rows="2" matInput placeholder="Please list the information that is not current and correct" formControlName="applicantPageCorrectReason" aria-describedby="applicantPageCorrect"></textarea>
               <mat-error *ngIf="validateApplicantPageCorrect()">
                This field is required
              </mat-error>
             </mat-form-field>
             <span class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
          </div>
        </div>
      </mat-card>
    </form>
  </div>
  <mat-card-content>
    <!--Applicant Form-->
    <form [formGroup]="applicantForm">
      <div class="flex flex-col">
        <div class="flex flex-col lg:flex-row gap-2">
          <!--Contact Information-->
          <mat-card>
            <mat-card-title>
              Contact Information
            </mat-card-title>
            <mat-card-content>
              <div class="flex flex-col lg:flex-row gap-2">
                <div class="flex flex-col gap-2 w-full lg:w-1/2">
                  <span id="entityNameLabel" class="f-s-16"><strong>Legal entity name</strong></span>
                  <mat-form-field class="w-full md:w-[40%]">
                    <input matInput formControlName="entityName" aria-describedby="entityNameLabel">
                    <mat-label style="color:red" *ngIf="applicantForm.get('entityName').value == ''">Entity Name*</mat-label>
                    <mat-label style="color:grey" *ngIf="applicantForm.get('entityName').value != ''">Entity Name</mat-label>
                    <mat-error *ngIf="applicantForm.get('entityName').invalid">
                      Please provide the legal entity name
                    </mat-error>
                  </mat-form-field>

                  <span class="f-s-16"><strong>Registered Business</strong></span>
                  <div class="flex flex-row">
                    <div class="flex flex-col">
                      <span id="businessInOregon" class="text-wrap">Is the applicant registered as a business with the Secretary of State (SOS) in Oregon?</span>
                      <mat-radio-group aria-label="Select an option" formControlName="businessInOregon" [disabled]="renewal" aria-describedby="businessInOregon" class="gap-2">
                        <mat-radio-button [value]="true" >Yes</mat-radio-button>
                        <mat-radio-button [value]="false" >No</mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="validateBusinessInOregon()">This field is required</mat-error>
                    </div>
                    </div>
                    <div *ngIf="applicantForm.get('businessInOregon').value == true" class="flex flex-col gap-2">
                      <div class="flex flex-col">
                        <span id="registrationNumberLabel">Oregon Secretary of State Registration Number</span>
                        <mat-form-field>
                          <input matInput placeholder="Registry Number" formControlName="secretaryofStateNumber" [readonly]="renewal" aria-describedby="registrationNumberLabel">
                        </mat-form-field>
                        <mat-error *ngIf="validateSecretaryofStateNumber()">
                          Secretary of State Registration Number is required
                        </mat-error>
                      </div>
                    </div>
                    <div *ngIf="!applicantForm.get('businessInOregon').value" class="flex flex-row">
                      <div class="flex flex-col">
                      <span id="registeredBusiness" class="text-wrap">Is the applicant registered as a business in another state, US territory or a freely associated state?</span>
                      <mat-radio-group aria-label="Select an option" formControlName="registeredBusiness" [disabled]="renewal" aria-describedby="registeredBusiness" class="gap-2">
                        <mat-radio-button [value]="true">Yes</mat-radio-button>
                        <mat-radio-button [value]="false">No</mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="validateBusinessInOtherState()">This field is required</mat-error>
                    </div>
                    </div>
                    <div *ngIf="applicantForm.get('registeredBusiness').value == true && applicantForm.get('businessInOregon').value == false" class="flex flex-col gap-2">
                      <div class="flex flex-col">
                        <span id="otherStateRegistrationLabel">Please provide the location (state, US territory, or freely associated state) where the Service Center is registered as a business and the registration number.</span>

                        <mat-form-field>
                          <input matInput placeholder="Location Registered" formControlName="registeredIn" [readonly]="renewal" aria-describedby="otherStateRegistrationLabel">
                        </mat-form-field>
                        <mat-error *ngIf="validateRegisteredLocation()">Business Location is required</mat-error>

                        <mat-form-field>
                          <input matInput placeholder="Registration Number" formControlName="registryNumber" [readonly]="renewal" aria-describedby="otherStateRegistrationLabel">
                        </mat-form-field>
                        <mat-error *ngIf="validateRegistryNumber()">Registration Number is required</mat-error>
                      </div>
                    </div>
                    <mat-checkbox formControlName="registrationAttestation">
                      <span [ngClass]="!applicantForm.get('registrationAttestation').value && applicantForm.get('registrationAttestation').touched? 'text-red-400' : ''"
                            class="text-wrap"><strong>I understand licensees that are required to be registered with the Oregon Secretary of State must register prior
                              to receiving a license and maintain registration per OAR 333-333-4400 (11).</strong></span>
                    </mat-checkbox>

                  <div class="flex flex-col">
                    <span id="affiliatedLicensesLabel" class="f-2-20"><strong>Other OPS Licenses or Permits</strong></span>
                    <mat-checkbox formControlName="previousLicense" (change)="validatePreviousLicense()">
                      <span class="text-wrap">
                        Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services
                      </span>
                    </mat-checkbox>
                    <div class="m-t-8 flex flex-col" *ngIf="this.applicantForm.get('previousLicense').value">
                      <span>Please provide the license id(s) for each Oregon Psilocybin Services license.</span>
                      <mat-form-field>
                        <input matInput formControlName="affiliatedLicenses"
                          (blur)="validatePreviousLicense()" aria-describedby="affiliatedLicensesLabel">
                          <mat-label style="color:red" *ngIf="applicantForm.get('affiliatedLicenses').value == ''">Affiliated Licenses*</mat-label>
                          <mat-label style="color:grey" *ngIf="applicantForm.get('affiliatedLicenses').value != ''">Affiliated Licenses</mat-label>
                        <mat-error *ngIf="validatePreviousLicense()">
                          Please provide all license numbers
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col gap-2w-full lg:w-1/2">
                  <div class="flex flex-col md:flex-row gap-2">
                    <div class="flex flex-col w-full md:w-1/2">
                      <span id="primaryContactPhoneLabel" class="f-s-16"><strong>Contact Phone</strong></span>
                      <mat-form-field>
                        <input matInput formControlName="primaryContactNumber"
                          mask="(000) 000-0000 000000" [validation]="false" aria-describedby="primaryContactPhoneLabel">
                          <mat-label style="color:red" *ngIf="applicantForm.get('primaryContactNumber').value == ''">Phone*</mat-label>
                          <mat-label style="color:grey" *ngIf="applicantForm.get('primaryContactNumber').value != ''">Phone</mat-label>
                        <mat-error *ngIf="applicantForm.get('primaryContactNumber').invalid">
                          A name is required
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col w-full md:w-1/2">
                      <span id="preferredLanguageLabel" class="f-s-16"><strong>Preferred Language</strong></span>
                      <mat-form-field>
                        <input matInput placeholder="Language" formControlName="language" aria-describedby="preferredLanguageLabel">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex flex-col md:flex-row gap-2">
                    <div class="flex flex-col w-full md:w-1/2">
                      <span id="primaryContactEmailLabel" class="f-s-16"><strong>Email Address</strong></span>
                      <mat-form-field>
                        <input matInput formControlName="primaryContactEmail" aria-describedby="primaryContactEmailLabel">
                        <mat-label style="color:red" *ngIf="applicantForm.get('primaryContactEmail').value == ''">Email*</mat-label>
                        <mat-label style="color:grey" *ngIf="applicantForm.get('primaryContactEmail').value != ''">Email</mat-label>
                        <mat-error *ngIf="applicantForm.get('primaryContactEmail').hasError('required')">
                          Please enter an email adress
                        </mat-error>
                        <mat-error *ngIf="applicantForm.get('primaryContactEmail').hasError('email')">
                          This doesn't look like a valid email address
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="flex flex-col w-full md:w-1/2">
                      <span id="confirmEmailLabel" class="f-s-16"><strong>Confirm Email Address</strong></span>
                      <mat-form-field>
                        <input matInput formControlName="confirmEmail" aria-describedby="confirmEmailLabel">
                        <mat-label style="color:red" *ngIf="applicantForm.get('confirmEmail').value == ''">Confirm Email*</mat-label>
                        <mat-label style="color:grey" *ngIf="applicantForm.get('confirmEmail').value != ''">Confirm Email</mat-label>
                        <mat-error *ngIf="validateEmail()">
                          Email does not match
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="flex flex-col md:flex-row gap-2">
          <!--Addresses-->
          <mat-card class="w-full md:w-[60%]">
            <mat-card-title>Addresses</mat-card-title>
            <mat-card-content>
              <div class="flex flex-col">
                <span id="headquartersAddressLabel" class="f-s-18"><strong>Headquarters Address</strong></span>
                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:w-[50%]">
                    <input matInput formControlName="headquartersStreet" aria-describedby="headquartersAddressLabel">
                    <mat-label style="color:red" *ngIf="applicantForm.get('headquartersStreet').value == ''">Street Apt/Unit/Suite*</mat-label>
                    <mat-label style="color:grey" *ngIf="applicantForm.get('headquartersStreet').value != ''">Street Apt/Unit/Suite</mat-label>
                    <mat-error *ngIf="applicantForm.get('headquartersStreet').invalid">
                      Please provide a street
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="w-full md:w-[50%]">
                    <input matInput formControlName="headquartersCity" aria-describedby="headquartersAddressLabel">
                    <mat-label style="color:red" *ngIf="applicantForm.get('headquartersCity').value == ''">City*</mat-label>
                    <mat-label style="color:grey" *ngIf="applicantForm.get('headquartersCity').value != ''">City</mat-label>
                    <mat-error *ngIf="applicantForm.get('headquartersCity').invalid">
                      Please provide a city
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full">
                    <mat-label style="color:red" *ngIf="applicantForm.get('headquartersState').value == ''">State/US territory/freely associated state*</mat-label>
                    <mat-label *ngIf="applicantForm.get('headquartersState').value != ''">State/US territory/freely associated state</mat-label>
                    <mat-select formControlName="headquartersState" aria-describedby="headquartersAddressLabel">
                      <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="applicantForm.get('headquartersState').invalid">
                      Please select a state
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:w-[30%]">
                    <input matInput formControlName="headquartersZip" aria-describedby="headquartersAddressLabel">
                    <mat-label style="color:red" *ngIf="applicantForm.get('headquartersZip').value == ''">Zip*</mat-label>
                    <mat-label style="color:grey" *ngIf="applicantForm.get('headquartersZip').value != ''">Zip</mat-label>
                    <mat-error *ngIf="applicantForm.get('headquartersZip').hasError('required')">
                      Please provide a zipcode
                    </mat-error>
                    <mat-error *ngIf="applicantForm.get('headquartersZip').hasError('pattern')">
                      Zipcode should match this format: 99999 or 99999-1234
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field *ngIf="applicantForm.get('headquartersState').value === 'OR'" class="w-full md:w-[30%]">
                    <mat-label style="color:red" *ngIf="applicantForm.get('headquartersCounty').value == ''">County*</mat-label>
                    <mat-label style="color:grey" *ngIf="applicantForm.get('headquartersCounty').value != ''">County</mat-label>
                    <mat-select formControlName="headquartersCounty" aria-describedby="headquartersAddressLabel">
                      <mat-option>-- None --</mat-option>
                      <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col">
                <div class="flex flex-col md:flex-row gap-6">
                  <span id="physicalAddressLabel" class="f-s-18"><strong>Physical Address</strong></span>
                  <mat-checkbox formControlName="physicalIsHeadquarters" (change)="physicalIsSame()">
                    Same as Headquarters
                  </mat-checkbox>
                </div>
                <div [@slideInOut] *ngIf="!applicantForm.get('physicalIsHeadquarters').value" class="flex flex-col">
                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full md:w-[50%]">
                      <input matInput formControlName="physicalStreet"
                        (blur)="validatePhysicalStreet()" aria-describedby="physicalAddressLabel">
                        <mat-label style="color:red" *ngIf="applicantForm.get('physicalStreet').value == ''">Street Apt/Unit/Suite*</mat-label>
                        <mat-label style="color:grey" *ngIf="applicantForm.get('physicalStreet').value != ''">Street Apt/Unit/Suite</mat-label>
                      <mat-error *ngIf="validatePhysicalStreet()">
                        Please provide a street
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[50%]">
                      <input matInput formControlName="physicalCity" (blur)="validatePhysicalCity()" aria-describedby="physicalAddressLabel">
                      <mat-label style="color:red" *ngIf="applicantForm.get('physicalCity').value == ''">City*</mat-label>
                      <mat-label style="color:grey" *ngIf="applicantForm.get('physicalCity').value != ''">City</mat-label>
                      <mat-error *ngIf="validatePhysicalCity()">
                        Please provide a city
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full">
                      <mat-label style="color:red" *ngIf="applicantForm.get('physicalState').value == ''">State/US territory/freely associated state*</mat-label>
                      <mat-label *ngIf="applicantForm.get('physicalState').value != ''">State/US territory/freely associated state</mat-label>
                      <mat-select formControlName="physicalState" (blur)="validatePhysicalState()" aria-describedby="physicalAddressLabel">
                        <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="validatePhysicalState()">
                        Please provide a state, US territory or freely associated state
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full md:w-[30%]">
                      <input matInput formControlName="physicalZip" (blur)="validatePhysicalZip()" aria-describedby="physicalAddressLabel">
                      <mat-label style="color:red" *ngIf="applicantForm.get('physicalZip').value == ''">Zip*</mat-label>
                      <mat-label style="color:grey" *ngIf="applicantForm.get('physicalZip').value != ''">Zip</mat-label>
                      <mat-error *ngIf="validatePhysicalZip()">
                        Please provide a zipcode
                      </mat-error>
                      <mat-error *ngIf="applicantForm.get('physicalZip').hasError('pattern')">
                        Zipcode should match this format: 99999 or 99999-1234
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field *ngIf="applicantForm.get('physicalState').value === 'OR'" class="w-full md:w-[30%]">
                      <mat-label style="color:red" *ngIf="applicantForm.get('physicalCounty').value == ''">County*</mat-label>
                      <mat-label style="color:grey" *ngIf="applicantForm.get('physicalCounty').value != ''">County</mat-label>
                      <mat-select formControlName="physicalCounty" aria-describedby="physicalAddressLabel">
                        <mat-option>-- None --</mat-option>
                        <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="flex flex-col">
                <div class="flex flex-col md:flex-row gap-4">
                  <span id="mailingAddressLabel" class="f-s-18"><strong>Mailing Address</strong></span>
                  <mat-checkbox formControlName="mailingIsHeadquarters" (change)="mailingIsSame()"
                    *ngIf="!applicantForm.get('mailingIsPhysical').value">
                    Same as Headquarters
                  </mat-checkbox>
                  <mat-checkbox formControlName="mailingIsPhysical" (change)="mailingIsSame()"
                    *ngIf="!applicantForm.get('mailingIsHeadquarters').value">
                    Same as Physical
                  </mat-checkbox>
                </div>

                <div [@slideInOut] *ngIf="!applicantForm.get('mailingIsHeadquarters').value &&
                                                        !applicantForm.get('mailingIsPhysical').value" class="flex flex-col">
                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full md:w-[50%]">
                      <input matInput formControlName="mailingStreet"
                        (blur)="validateMailingStreet()" aria-describedby="mailingAddressLabel">
                      <mat-label style="color:red" *ngIf="applicantForm.get('mailingStreet').value == ''">Street Apt/Unit/Suite*</mat-label>
                      <mat-label style="color:grey" *ngIf="applicantForm.get('mailingStreet').value != ''">Street Apt/Unit/Suite</mat-label>
                      <mat-error *ngIf="validateMailingStreet()">
                        Please provide a street
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[50%]">
                      <input matInput formControlName="mailingCity" (blur)="validateMailingCity()" aria-describedby="mailingAddressLabel">
                      <mat-label style="color:red" *ngIf="applicantForm.get('mailingCity').value == ''">City*</mat-label>
                      <mat-label style="color:grey" *ngIf="applicantForm.get('mailingCity').value != ''">City</mat-label>
                      <mat-error *ngIf="validateMailingCity()">
                        Please provide a city
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full">
                      <mat-label style="color:red" *ngIf="applicantForm.get('mailingState').value == ''">State/US territory/freely associated state*</mat-label>
                      <mat-label *ngIf="applicantForm.get('mailingState').value != ''">State/US territory/freely associated state</mat-label>
                      <mat-select formControlName="mailingState" (blur)="validateMailingState()" aria-describedby="mailingAddressLabel">
                        <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="validateMailingState()">
                        Please provide a state, US territory or freely associated state
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full md:w-[30%]">
                      <input matInput formControlName="mailingZip" (blur)="validateMailingZip()" aria-describedby="mailingAddressLabel">
                      <mat-label style="color:red" *ngIf="applicantForm.get('mailingZip').value == ''">Zip*</mat-label>
                      <mat-label style="color:grey" *ngIf="applicantForm.get('mailingZip').value != ''">Zip</mat-label>
                      <mat-error *ngIf="validateMailingZip()">
                        Please provide a zipcode
                      </mat-error>
                      <mat-error *ngIf="applicantForm.get('mailingZip').hasError('pattern')">
                        Zipcode should match this format: 99999 or 99999-1234
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field *ngIf="applicantForm.get('mailingState').value === 'OR'" class="w-full md:w-[30%]">
                      <mat-label style="color:red" *ngIf="applicantForm.get('mailingCounty').value == ''">County*</mat-label>
                      <mat-label style="color:grey" *ngIf="applicantForm.get('mailingCounty').value != ''">County</mat-label>
                      <mat-select formControlName="mailingCounty" aria-describedby="mailingAddressLabel">
                        <mat-option>-- None --</mat-option>
                        <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

              </div>

            </mat-card-content>
          </mat-card>

          <!--Individual Applicants-->
          <mat-card class="w-full md:w-[40%]">
            <mat-card-title>
              Individual Applicants/ Licensees
            </mat-card-title>
            <mat-card-content>
              <div class="flex flex-col gap-2">
                <div class="flex flex-col gap-1 md:flex-row md:gap-2 justify-start md:items-center">
                  <span>Available Applicants</span>
                  <span class="hidden md:block flex-1"></span>
                  <div *ngIf="!renewal" class="flex flex-wrap items-center gap-1 md:justify-end">
                    <span>Click</span>
                    <mat-icon color="primary">add</mat-icon>
                    <span>To Associate An Applicant</span>
                  </div>
                </div>
                <mat-table [dataSource]="applicantSource" matSort #applicantSort="matSort" aria-describedby="applicants"
                  class="mat-elevation-z8 p-t-0">
                  <ng-container matColumnDef="legalFirstName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>First</mat-header-cell>
                    <mat-cell [ngClass]="tableColor" tabindex="0" *matCellDef="let applicant">
                      <span class="mobile-label">First</span>
                      {{ applicant.legalFirstName }}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="legalLastName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Last</mat-header-cell>
                    <mat-cell [ngClass]="tableColor" tabindex="0" *matCellDef="let applicant">
                      <span class="mobile-label">Last</span>
                      {{ applicant.legalLastName }}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell [ngClass]="tableColor" *matCellDef="let applicant">
                      <button *ngIf="!licenseLocked && !renewal" type="button" mat-icon-button
                        (click)="addIndividualApplicant(applicant.id)" color="primary" aria-label="Associate Applicant">
                        <mat-icon>add</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="applicantColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: applicantColumns"></mat-row>
                </mat-table>
                <mat-paginator [pageSizeOptions]="[5, 20, 50]" #applicantPaginator="matPaginator">
                </mat-paginator>

                <span>Associated Applicants</span>
                <mat-table [dataSource]="associatedApplicantSource" matSort #associatedApplicantSort="matSort"
                  aria-describedby="Associated Applicants" class="mat-elevation-z8 p-t-0">
                  <ng-container matColumnDef="legalFirstName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>First</mat-header-cell>
                    <mat-cell [ngClass]="tableColor" tabindex="0" *matCellDef="let applicant">
                      <span class="mobile-label">First</span>
                      {{ applicant.legalFirstName }}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="legalLastName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Last</mat-header-cell>
                    <mat-cell [ngClass]="tableColor" tabindex="0" *matCellDef="let applicant">
                      <span class="mobile-label">Last</span>
                      {{ applicant.legalLastName }}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell [ngClass]="tableColor" *matCellDef="let applicant">
                      <button *ngIf="!licenseLocked && !renewal" type="button" mat-icon-button class="m-8"
                        (click)="deleteIndividualApplicant(applicant.id)" color="warn"
                        aria-label="Remove Applicant Association">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="applicantColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: applicantColumns"></mat-row>
                </mat-table>
                <mat-paginator [pageSizeOptions]="[5, 20, 50]" #associatedApplicantPaginator="matPaginator">
                </mat-paginator>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="flex flex-col lg:flex-row gap-2">
          <!--Upload Documents-->
          <mat-card class="w-full lg:w-1/2">
            <mat-card-title>
              <span *ngIf="documentsValid">
                Supporting Documents
              </span>
              <span *ngIf="!documentsValid" class="text-red-400">
                Supporting Documents Incomplete
              </span>
            </mat-card-title>
            <mat-card-content>
              <div class="flex flex-col">
                <span>You must provide a completed entity applicant information form</span>
                <div class="m-t-8 flex flex-col gap-2">
                  <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp,.mp4" class="file-input" (change)="uploadDocument($event)" #entityApplicantFileUpload />
                  <div class="flex flex-row gap-2">
                    <div class="file-upload">
                      <button type="button" mat-raised-button color="primary" class="upload-btn"
                        (click)="entityApplicantFileUpload.click()">
                        Browse
                        <mat-icon>attach_file</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!--Current Documents-->
          <mat-card class="w-full lg:w-1/2">
            <mat-card-title>
              <span *ngIf="documentsValid">Current Documents</span>
            </mat-card-title>
            <mat-card-content>
              <div class="flex flex-col">
                <div *ngIf="!sharedService.mobile" class="flex flex-row">
                  <span class="f-s-16 w-[30%]"><strong>File</strong></span>
                  <span class="f-s-16"><strong>Requirement</strong></span>
                </div>
                <div *ngFor="let document of applicant.applicantDocuments" class="grid grid-cols-1 gap-2 border-b border-gray-200 py-2 last:border-b-0 md:grid-cols-[30%_minmax(0,1fr)_auto] md:items-center md:gap-4">
                  <div class="flex w-full flex-col">
                    <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                    <span class="w-full break-words text-indigo-A700" style="cursor: pointer" (click)="downloadDocument(document.id, document.name)" title="{{document.name}}">{{document.name}}</span>
                  </div>
                  <div class="flex flex-col break-words md:min-w-0">
                    <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                    <span>Applicant Information</span>
                  </div>
                  <div class="flex items-center justify-start gap-2 md:justify-end">
                    <button *ngIf="!licenseLocked && !document.deprecated" type="button" mat-icon-button class="m-0 md:m-2"
                      (click)="deleteFile(document.id, document.name)" color="warn" aria-label="Delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                    <span *ngIf="document.deprecated" style="color:red">Deprecated</span>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
